import { cn } from '@noirproperties/ui/lib/utils';

type ContainerProps = {
  className?: string;
};

export function Container({
  className,
  ...props
}: React.PropsWithChildren<ContainerProps>) {
  return (
    <div
      className={cn('mx-auto max-w-7xl px-4 sm:px-6 lg:px-8', className)}
      {...props}
    />
  );
}
